import React from 'react';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  InputGroup,
  Select,
  Box,
} from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import { useFormContext } from 'react-hook-form';

import { SelectControlProps } from './types';

export const SelectControl = React.forwardRef<HTMLInputElement, any>(({
  name: fieldName,
  label,
  helper,
  error,
  isDisabled,
  isRequired,
  rules,
  list,
  ...props
}: SelectControlProps, forwardRef) => {
  const {
    register,
    getValues,
  } = useFormContext();

  const { ref: inputRef, ...rest } = register(fieldName!, {
    ...(isRequired && { required: 'This is required' }),
    ...rules,
    onBlur: () => {
      if (props.onBlur) props.onBlur(fieldName as any);
    },
    onChange: () => {
      if (props.onChange) props.onChange(fieldName as any);
    },
  });

  const mergedRef = (e: any) => {
    inputRef(e);
    if (forwardRef) (forwardRef as any).current = e;
  };

  return (
    <Box>
      <FormControl
        isInvalid={!!error}
        isDisabled={isDisabled}
        isRequired={isRequired}
        className={cx('InputContainer')}
      >
        <FormLabel className={cx('InputLabel')}>
          {label}
        </FormLabel>
        <InputGroup>
          <Select
            className={cx('Select')}
            {...props}
            {...rest}
            ref={mergedRef}
          >
            <option value=""> </option>
            {list?.length && list.map(({ value, name }: any, idx: number) => (
              <option key={idx} value={value} selected={getValues(fieldName!) === value}>
                {name}
              </option>
            ))}
          </Select>
        </InputGroup>

        {helper && !error && <FormHelperText className={cx('InputHelper')}>{helper}</FormHelperText>}
        {error && <FormErrorMessage className={cx('InputError')}>{error}</FormErrorMessage>}
      </FormControl>
    </Box>
  );
});
